import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface PredictionOption {
  id: number;
  text: string;
  probability: number;
  price: number;
}
interface PredictionCardProps {
  id: number;
  question: string;
  description: string;
  category: string;
  endDate: string;
  totalVolume: string;
  options: PredictionOption[];
  imageUrl: string;
  isLarge?: boolean;
}
export const PredictionCard = ({
  id,
  question,
  description,
  category,
  endDate,
  totalVolume,
  options,
  imageUrl,
  isLarge = false
}: PredictionCardProps) => {
  const [isExpanded, setIsExpanded] = useState(isLarge);
  const [selectedOption, setSelectedOption] = useState<number | null>(null);
  const [betAmount, setBetAmount] = useState('10');
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const handleOptionSelect = (optionId: number) => {
    setSelectedOption(optionId);
  };
  return <div className={`bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow ${isLarge ? 'flex flex-col' : ''}`} data-id="element-198">
      <div className="relative" data-id="element-199">
        <img src={imageUrl} alt={question} className={`w-full ${isLarge ? 'h-64' : 'h-48'} object-cover`} data-id="element-200" />
        <div className="absolute top-3 right-3 bg-blue-600 text-white text-xs font-bold px-2 py-1 rounded capitalize" data-id="element-201">
          {category}
        </div>
      </div>
      <div className="p-4" data-id="element-202">
        <div className="flex justify-between items-start mb-2" data-id="element-203">
          <h3 className={`font-bold text-gray-900 ${isLarge ? 'text-xl' : 'text-lg'} hover:text-blue-600 transition-colors`} data-id="element-204">
            {question}
          </h3>
          <button onClick={toggleExpand} className="text-gray-500 hover:text-gray-700 ml-2 mt-1" data-id="element-205">
            {isExpanded ? <ChevronUpIcon className="h-5 w-5" data-id="element-206" /> : <ChevronDownIcon className="h-5 w-5" data-id="element-207" />}
          </button>
        </div>
        {isExpanded && <p className="text-gray-600 text-sm mb-4" data-id="element-208">{description}</p>}
        <div className="flex justify-between text-xs text-gray-500 mb-4" data-id="element-209">
          <span data-id="element-210">Closes: {endDate}</span>
          <span data-id="element-211">Volume: {totalVolume}</span>
        </div>
        <div className="space-y-3 mb-4" data-id="element-212">
          {options.map(option => <div key={option.id} className={`border rounded-md p-3 cursor-pointer transition-colors ${selectedOption === option.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:border-blue-300'}`} onClick={() => handleOptionSelect(option.id)} data-id="element-213">
              <div className="flex justify-between items-center" data-id="element-214">
                <div className="font-medium" data-id="element-215">{option.text}</div>
                <div className="text-sm font-bold" data-id="element-216">{option.probability}%</div>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-1.5 mt-2" data-id="element-217">
                <div className="bg-blue-600 h-1.5 rounded-full" style={{
              width: `${option.probability}%`
            }} data-id="element-218"></div>
              </div>
            </div>)}
        </div>
        {selectedOption && <div className="border-t border-gray-100 pt-3" data-id="element-219">
            <div className="flex items-center justify-between mb-3" data-id="element-220">
              <div className="text-sm text-gray-600" data-id="element-221">
                Your prediction amount:
              </div>
              <div className="relative w-24" data-id="element-222">
                <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" data-id="element-223">
                  $
                </span>
                <input type="number" value={betAmount} onChange={e => setBetAmount(e.target.value)} className="w-full pl-7 pr-2 py-1 border border-gray-300 rounded text-right" min="1" data-id="element-224" />
              </div>
            </div>
            <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 rounded transition-colors" data-id="element-225">
              Place Prediction
            </button>
          </div>}
      </div>
    </div>;
};